import React, { useState, useEffect } from 'react';
import './Header.css';

import { HeaderItem, MobileNavbar, Logo } from '../../components';
import { navbar } from '../../constants';

import { FaPhoneAlt, FaEnvelope, FaFacebookF, FaTwitter, FaInstagram, FaLinkedin, FaRegUser, FaCartArrowDown, FaBars, FaTimes, FaSearch } from 'react-icons/fa';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';



const Header = (props) => {

  const { cart } = props;

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [click, setClick] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [searchValue, setSearchValue] = useState('');


  /********** 1-Manage Sticky Header ***********/
  // Manage Sticky Header 
  useEffect(() => {
    window.addEventListener('scroll', stickyHeader);
    return () => {
      window.removeEventListener('scroll', stickyHeader);
    };
  });

  // Add active class to header on scroll
  const stickyHeader = (e) => {
    const header = document.querySelector('.header');
    const scrollTop = window.scrollY;
    scrollTop >= 60 ? header.classList.add('active') : header.classList.remove('active');
  };

  /********** 2-Manage On Scroll  ***********/
  // Manage On Scroll Functionality
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  // Handle scroll event
  const handleScroll = (e) => {
    /* Close Menubar On Scroll */
    const navbar = document.querySelector('.navbar');
    navbar.classList.remove('active');
    setClick(false);
    setOpen(false);
    setIsActive(false);
  };

  /********** 3-Manage Mobile Navbar ***********/
  // Handle click on menu button
  const handleClick = () => {
    setIsActive(false);
    setClick((prevClick) => !prevClick);
    setOpen((prevOpen) => !prevOpen);
  };

  // Close the Navbar between navigation
  useEffect(() => {
    setOpen(false);
    setClick(false);
    setIsActive(false);
  }, [pathname]);

  /********** 4-Manage Search Functionality ***********/
  // Function to handle search icon click
  const handleSearchIconClick = () => {
    setIsActive(!isActive);
    if (!isActive) {
      setSearchValue('');
    }
  };

  // Function to handle search form submit
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchValue.trim() !== '') {
      navigate(`/blogs/search/${searchValue}`);
      setSearchValue(''); // Reset the search value to clear the input field
    }
  };

  // Function to handle search input change
  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };




  const handLoginChange = () => {
    // 根據 isLogin 設置目標路徑
    let linkTo = '';
    let isLogin = false;

    if (Cookies.get('cookieConsent') === 'accepted') {
      const isLoginCookie = Cookies.get('isLogin');
      isLogin = isLoginCookie === 'true'; // 將字符串轉換為布爾值
    } else {
      //沒用Cookie的路線暫時不處理
      isLogin = false;
    }

    if (isLogin === true) {
      linkTo = "/MemberProfile";
    } else {
      linkTo = '/LineLogin';
    } 

    navigate(linkTo);
  };

  return (
    <nav className='header'>

      {/* 2nd Header Container */}
      <div className='header-2'>

        <div className='icon menu-btn' onClick={handleClick}>{click ? <FaTimes /> : <FaBars />}</div> {/* Menu Button */}

        {/* Logo */}
        <Logo />

        {/* Mobile Navbar */}
        <MobileNavbar isOpen={isOpen} />

        <div className='container'>

          {/* Desktop Navbar */}
          <div className='navbar'>
            {
              navbar.map((item) => {
                return <HeaderItem key={item.id} {...item} />
              })
            }
          </div>

          {/* Header Icons Container */}
          <div className='icon-container'>
            <FaRegUser className='icon' onClick={handLoginChange} />{/* Login Link */}
          </div>
        </div>

        {/* Search Container */}
        <form onSubmit={handleSearchSubmit} className={`search-container ${isActive ? 'active' : ''}`}>
          <input type='text' id='search' placeholder='Search here...' value={searchValue} onChange={handleSearchChange} required /> {/* Search Input */}
          <button type="submit"><FaSearch className='icon' /></button> {/* Search Button */}
        </form>

      </div>

    </nav>
  );
}

export default Header;